export default function videoOrientation() {
    document.addEventListener("DOMContentLoaded", function() {
        const videoItems = document.querySelectorAll(".courts__item video");
        const courtsContainer = document.querySelector(".courts__items");
    
        if (videoItems.length === 0) {
            return;
        }
    
        const firstVideo = videoItems[0];
        let videoChecked = false;
    
        function checkVideoOrientation() {
            if (firstVideo.readyState > 0 || firstVideo.videoWidth > 0) {
                videoChecked = true;
                const width = firstVideo.videoWidth;
                const height = firstVideo.videoHeight;
    
                if (width > height) {
                    courtsContainer.classList.add("horizontal-videos");
                }
                
                firstVideo.removeEventListener("loadedmetadata", checkVideoOrientation);
            }
        }
    
        firstVideo.addEventListener("loadedmetadata", checkVideoOrientation);
    
        if (firstVideo.readyState > 0) {
            checkVideoOrientation();
        }
        
        setTimeout(() => {
            if (!videoChecked) {
                checkVideoOrientation();
            }
        }, 500); 
    });
}